import React from 'react';
import CartItems from '../components/cartItems/cartItems';

const Cart = () => {
    return (
        <div >
           <CartItems/> 
        </div>
    );
}

export default Cart;
